// utils/cart.js

export function getCart() {
  const cart = localStorage.getItem("cart");
  return cart ? JSON.parse(cart) : [];
}

export function saveCart(cart) {
  localStorage.setItem("cart", JSON.stringify(cart));
  window.dispatchEvent(new Event("cartUpdated"));
}

export function updateCart(product, quantity) {
  if (quantity === 0) {
    return removeFromCart(product.product__ID);
  }

  const cart = getCart();
  const existingProductIndex = cart.findIndex(
    item => item.product.product__ID === product.product__ID
  );

  if (existingProductIndex !== -1) {
    cart[existingProductIndex].quantity = quantity;
    cart[existingProductIndex].product = product; // Optional: keep updated product info
  } else {
    cart.push({ product, quantity });
  }

  saveCart(cart);
}

export function decreaseFromCart(productId) {
  const cart = getCart();
  const index = cart.findIndex(item => item.product.product__ID === productId);

  if (index !== -1) {
    if (cart[index].quantity > 1) {
      cart[index].quantity -= 1;
    } else {
      cart.splice(index, 1);
    }
    saveCart(cart);
  }
}

export function removeFromCart(productId) {
  const cart = getCart().filter(item => item.product.product__ID !== productId);
  saveCart(cart);
  window.dispatchEvent(new Event("cartUpdated"));

}

export function clearCart() {
  localStorage.removeItem("cart");
}

export function getProductFromCart(productId) {
  const cart = getCart();
  return cart.find(item => item.product.product__ID === productId) || null;
}
